import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { ModePosEntreprise } from '../services/mode-pos-entreprise';
import { sessionSeuleGuard } from './auth.guard';

/**
 * Plan « Aucun » : aucune route du POS mobile ne s'ouvre, l'usager va a l'ecran qui
 * explique pourquoi. Pose sur `canActivateChild` du layout, apres `authGuard` : Angular
 * attend la fin du garde du parent avant ceux des enfants, donc la lecture du mode
 * n'est jamais lancee sans session.
 */
export const modePosGuard: CanActivateChildFn = async () => {
    const mode = inject(ModePosEntreprise);
    const router = inject(Router);
    await mode.assurerCharge();
    return mode.estAucun() ? router.createUrlTree(['/plan-sans-mobile']) : true;
};

/** Routes de vente et de caisse : reservees au mode SALES ; en RH, retour a l'accueil. */
export const venteSeulementGuard: CanActivateFn = async () => {
    const mode = inject(ModePosEntreprise);
    const router = inject(Router);
    await mode.assurerCharge();
    return mode.estVente() ? true : router.createUrlTree(['/home']);
};

/**
 * Ecran « Votre plan n'inclut pas l'application mobile » : session valide ET plan
 * « Aucun ». Les deux verifications s'enchainent dans CE garde plutot que dans un
 * tableau de gardes, que le routeur lance en parallele — la lecture du mode ne doit
 * pas partir avant d'avoir une session.
 */
export const sansMobileGuard: CanActivateFn = async () => {
    const mode = inject(ModePosEntreprise);
    const router = inject(Router);
    if (!(await sessionSeuleGuard())) return false;
    await mode.assurerCharge();
    return mode.estAucun() ? true : router.createUrlTree(['/home']);
};
